import React from 'react'
import PropTypes from 'prop-types'
import {withStyles} from 'material-ui/styles'
import {grey} from 'material-ui/colors'
import MUITabs, {Tab} from 'material-ui/Tabs'
import {RENT_AVAILABLE} from "../../../App"
import {tabs as tabsText} from '../text'

const styles = theme => ({
  button: {
    height: 60,
    transition: 'background-color ' + theme.transitions.duration.short + 'ms ' + theme.transitions.easing.easeInOut,
    '&:hover': {
      textDecoration: 'none',
      backgroundColor: 'rgba(34, 34, 34, 0.12)',
    }
  },
  buttonNoHightlight: {
    color: grey[500],
  },
})

const communityTab = (classes, goCommunity) => RENT_AVAILABLE
    ? <Tab value={'community'} label={tabsText.community} onClick={goCommunity} className={classes.button}/>
    : null

const Tabs = ({classes, tab, goCommunity, goMyStuff}) => (
  <div>
    <MUITabs
      value={tab ? tab : false}
      centered={false}
      fullWidth={false}
      indicatorColor="secondary"
      className={classes.Tabs}
    >
      {communityTab(classes, goCommunity)}
      <Tab value={'yours'} label={tabsText.myCatalog} onClick={goMyStuff} className={classes.button}/>
    </MUITabs>
  </div>
)

Tabs.propTypes = {
  tab: PropTypes.oneOf(['community', 'yours', '', 'catalog']),
  goCommunity: PropTypes.func.isRequired,
  goMyStuff: PropTypes.func.isRequired,
}

export default withStyles(styles, {withTheme: true})(Tabs)



// WEBPACK FOOTER //
// ./src/sections/header/components/tabs.js